/*
    *** Props ***
    component:      A react component, containing the step content.
    prevStep:       Go to previous step.
    nextStep:       Go to next step.
    onCancel:       Handle to call when user cancels form.
    onChangeValue:  Changes the specific value in form values.
    onSubmit:       Triggers onSubmit on PantaForm, of all form values.
    resetValues:    Resets all form values.
    values:         Object containing all current form values.
*/

import React, { FunctionComponent, useEffect } from 'react';
import { PantaFormStepProps } from '../types';
import './Scss/panta-form-step.scss';

const PantaFormStep: FunctionComponent<PantaFormStepProps> = ({
    component,
    stepProps,
    ...props
}) => {
    const StepComponent = component;
    const propz = { ...stepProps, ...props };

    useEffect(() => {
        // Scroll to top when switching steps
        if (document) {
            const fullscreen = document.querySelector('.full-screen.open')
            if (fullscreen) {
                fullscreen.scrollTop = 0
            }
        }
    }, []);

    return (
        <div className='panta-form-step'>
            <StepComponent {...propz} />
        </div>
    );
}

PantaFormStep.displayName = 'PantaFormStep';

export default PantaFormStep;
